module.exports = __webpack_public_path__ + "img/inflcosmall.9d81dc92.png";